import dhhtimages from "@/assets/images/screenshots/huehear/dhhtimages";
import strainprintImages from "@/assets/images/screenshots/strainprint/strainprintImages";
import cobblImages from "@/assets/images/screenshots/cobbl/cobblImages";
export default [
  {
    categoryName: "web",
    items: [
      {
        title: "Chicago Cubs x Artists",
        stack: ["VueJS"],
        thumbnail: require("@/assets/images/screenshots/cubs/cubs-logo.svg"),
        link: "https://cubs.fanportal-mlb.com/artists",
      },
      {
        title: "SewingArmy - PPE Donation System",
        stack: ["VueJS", "NodeJS"],
        thumbnail: require("@/assets/images/screenshots/sewingarmy/sewingArmyLogo.png"),
        link: "https://sewingarmy.vipfanportal.com",
        description: "sewingarmy.desc",
      },
      {
        title: "Hue Hear",
        stack: ["ReactJS", "NodeJS", "Apple MusicKit API", "Spotify API"],
        thumbnail: require("@/assets/images/screenshots/huehear/dhht-0.png"),
        link: "https://huehear.com",
        gallery: dhhtimages,
        isHtmlDescription: true,
        description: "huehear.desc",
      },
      {
        title: "Samir Rehem",
        stack: ["VueJS", "Headless Wordpress CMS"],
        thumbnail: require("@/assets/images/screenshots/samir/samirRehem.png"),
        link: "https://samirrehem.com",
      },
      {
        title: "Las Vegas Raiders",
        stack: ["VueJS", "PHP"],
        thumbnail: require("@/assets/images/screenshots/raiders/logo.png"),
        link: "https://raiders.vipfanportal.com/2020/",
      },
      {
        title: "Royal Ascot",
        stack: ["VueJS", "PHP"],
        thumbnail: require("@/assets/images/screenshots/ascot/logo.svg"),
        link: "https://royalascot.vipfanportal.com/2019/",
      },
      {
        title: "Philadelphia 76ers",
        stack: ["VueJS", "PHP"],
        thumbnail: require("@/assets/images/screenshots/76ers/logo.png"),
        link: "https://76ers.vipfanportal.com/2020",
      },
      {
        title: "New Jersey Devils",
        stack: ["VueJS", "PHP"],
        thumbnail: require("@/assets/images/screenshots/devils/devils.svg"),
        link: "https://devilsblackandred.com",
      },
      {
        title: "New York Islanders",
        stack: ["VueJS", "PHP"],
        thumbnail: require("@/assets/images/screenshots/islanders/logo.svg"),
        link: "https://islanders.vipfanportal.com/seats/",
      },
      {
        title: "San Antonio Spurs",
        stack: ["VueJS", "PHP"],
        thumbnail: require("@/assets/images/screenshots/spurs/spurs.png"),
        link: "https://spurs.vipfanportal.com/2020/",
      },
      // {
      //   title: "Fulham FC",
      //   stack: ["VueJS", "PHP"],
      //   thumbnail: require("@/assets/images/screenshots/fulham/fulham.png"),
      //   link: "https://fulhamfc.vipfanportal.com/2020/",
      // },
      // {
      //   title: "Arsenal FC",
      //   stack: ["VueJS", "PHP"],
      //   thumbnail: require("@/assets/images/screenshots/arsenal/logo.png"),
      //   link: "https://myrenewal.arsenal.com",
      // },
    ],
  },
  {
    categoryName: "app",
    items: [
      {
        title: "Strainprint",
        stack: ["React Native", "iOS", "Android"],
        thumbnail: require("@/assets/images/screenshots/strainprint/demo1.png"),
        link: "https://strainprint.ca/",
        isHtmlDescription: true,
        gallery: strainprintImages,
        description: "strainprint.desc",
      },
      {
        title: "Cobbl",
        gallery: cobblImages,
        stack: ["React Native", "iOS", "Android"],
        thumbnail: require("@/assets/images/screenshots/cobbl/cobbl.png"),
        link: "https://cobblparking.com",
        isHtmlDescription: true,
        description: "cobbl.desc",
      },
    ],
  },
];
